/* eslint camelcase: 0 */
import { config } from '@v4/config.js';
import { doRequest, request } from '@v4/http/request';
import { stringifyQueryParams, stringifyUrl } from '@v4/common/utils/url';
const { API_URL } = config;

/**
 * Get makes list
 *
 * @returns {Promise<*>}
 */
export const getMakesList = async () => {
    const url = `${API_URL}/dkwp/v2/car/makes`;

    const response = await doRequest(url);

    return await response.json();
};

/**
 * Get models list
 *
 * @param makeName
 * @returns {Promise<*>}
 */
export const getModelsList = async (makeName) => {
    const url = `${API_URL}/dkwp/v2/car/${makeName}/models`;

    const response = await doRequest(url);

    const json = await response.json();

    return json.models;
};

/**
 * Get versions list
 *
 * @param makeName
 * @param modalName
 * @returns {Promise<*>}
 */
export const getVersionsList = async (makeName, modelName, query = {}) => {
    const url = stringifyUrl({ url: `${API_URL}/dkwp/v2/car/${makeName}/${modelName}/versions`, query });

    const response = await doRequest(url);

    const json = await response.json();

    return json;
};

/**
 * Get offer types
 */
export const getOfferTypes = () => request(`${API_URL}/dkwp/v3/offer/types/`);

/**
 * Get suggestions list
 *
 * @param {String} submodelId - Vehicle submodel Id
 * @param {Number} [count=10] - Limit result size
 * @param {Array<string>} selectedVehicles - List of `submodelCommercialUrlCode`
 * @returns {Promise<*>}
 */
export const getSuggestionsListByModel = async (submodelId = '', count = 10) =>
    request(`${API_URL}/dkwp/v3/car/suggest/${submodelId}/?row=${count}`);

/**
 * Get vehicles to compare
 *
 * @param vehicles
 * @returns {Promise<*>}
 */
export const getCompareData = async (vehicles = []) => {
    const searchParams = {};

    const versions = [];
    vehicles.forEach((v) => {
        if (v.vehicleHistoricalId) {
            versions.push(v.vehicleHistoricalId);
        }
    });

    const totalVersions = versions.length;

    if (totalVersions && totalVersions === vehicles.length) {
        searchParams.vehicleHistoricalId = versions.join('|');
    } else {
        const error = new Error('Compare Page API call — vehicle missing vehicleHistoricalId.');

        Sentry.captureException(error, {
            tags: {
                category: 'compare-page',
                data: JSON.stringify(vehicles),
            },
        });

        throw error;
    }

    const url = `${API_URL}/dkwp/v2/car/compare${stringifyQueryParams(searchParams, { encode: true })}`;

    const response = await doRequest(url);

    const json = await response.json();

    return json.data;
};
